/**
 * @description 仅支持指定文件夹下一级ts文件 批量获取模块文件中的ts文件
 * @param modulesFiles 模块文件
 * @param module 模块文件夹名称 默认'module'
 * @returns 返回根据ts文件 {命名空间：default{}}
 *
 */
export const getModules = (modulesFiles: any, mname = 'modules') => {
	const modules: ObjectClass = {}
	Object.keys(modulesFiles).forEach(key => {
		const regExp = new RegExp(`(\.\/${mname}\/|\.ts)`, 'g')
		modules[key.replace(regExp, '')] = modulesFiles[key].default
	})
	return modules
}
/**
 * @description 批量获取模块文件中的ts文件 支持指定文件夹下多级ts文件
 * @param modulesFiles 模块文件
 * @returns 返回根据ts文件default[]合并
 */
export const getModulesArray = (modulesFiles: any) => {
	const modules: any[] = []
	Object.keys(modulesFiles).forEach(key => {
		modules.push(...modulesFiles[key].default)
	})
	return modules
}
